import { post } from 'src/lib/http';
import { HttpPrefix } from 'src/lib/wemeet-http-moudle';

export interface SetLastPosterParams {
  poster_id: string;
  event_id: string;
}
// 保存海报选项
export const setLastPoster = (data: SetLastPosterParams) => {
  const path = '/v2/activities/dashboard/event/set-last-poster';
  return post(HttpPrefix.WEMEET_TAPI, path, data).then((res) => {
    if (res.code !== 0) return Promise.reject(res.msg || res.err_detail);
    return true;
  });
};

// 获取海报选项
export const getLastPoster = (data: { event_id: string }) => {
  const path = '/v2/activities/dashboard/event/get-last-poster';
  return post(HttpPrefix.WEMEET_TAPI, path, data).then((res) => {
    const { code, data, msg } = res;
    if (code === 0) {
      return data;
    }
    return Promise.reject(msg);
  });
};
